import axios from 'axios'
import router from '@/router/routers'
import { Notification, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import Config from '@/settings'
import { findForbiddenFileInFormData, getForbiddenFileTip } from '@/utils/fileType'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: Config.timeout // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['Content-Type'] = 'application/json'

    // 上传文件类型兜底校验：拦截 html/svg/js/xml/exe/jsp 等存在脚本执行风险的文件
    const forbiddenFile = findForbiddenFileInFormData(config.data)
    if (forbiddenFile) {
      const message = getForbiddenFileTip(forbiddenFile)
      Notification.error({ title: message })
      const error = new Error(message)
      error.forbiddenFile = true
      return Promise.reject(error)
    }

    // 如果是开发环境
    if (process.env.NODE_ENV === 'development') {
      config.headers['S-Code'] = process.env.VUE_APP_SYSTEM_CODE
      config.headers['Org-No'] = process.env.VUE_APP_ORG_CODE
    }

    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// 登录失效弹窗
let logoutWarngingFlag = false
// response 拦截器
service.interceptors.response.use(
  response => {
    // http code处理
    const code = response.status
    if (code < 200 || code > 300) {
      Notification.error({
        title: response.message
      })
      return Promise.reject(response.data)
    }
    // 文件流类型的
    if (response.request.responseType == 'blob') {
      return response.data
    }

    // 根据报文返回码处理
    const reCode = response.data.code
    // 静默请求跳过全局提示（如登录页匿名获取验证码加密场景ID），由调用方降级处理
    if (response.config.silentError && reCode !== 200) {
      return Promise.reject('error')
    }
    if (reCode === 401) {
      if (!logoutWarngingFlag) {
        logoutWarngingFlag = true
        MessageBox.confirm(
          '由于您长时间未操作，系统自动退出登录。',
          '系统提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning',
            showCancelButton: false,
          }
        ).then(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        }).catch(() => {
          logoutWarngingFlag = false
        })
      }
    } else if (reCode === 403) {
      router.push({ path: '/401' })
    } else if (reCode === 533) {
      // 533：登录密码已过期，交由全局密码过期弹窗处理（弹窗已打开时不重复打开）
      if (!store.state.user.pwdExpired) {
        store.commit('SET_PWD_EXPIRED', true)
      }
      return Promise.reject('error')
    } else if (reCode === 509) {
      if (!logoutWarngingFlag) {
        logoutWarngingFlag = true
        MessageBox.confirm(
          response.data.message,
          '系统提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning',
            showCancelButton: false
          }
        ).then(() => {
          store.dispatch('LogOut').then(() => {
            location.reload()
          })
        }).catch(() => {
          logoutWarngingFlag = false
        });
      }
    } else if(reCode === 500) {
			Notification.error({
			  title: response.data.message
			})
			return Promise.reject('error')
		} else if (reCode !== 200) {
      Notification.warning({
        title: response.data.message
      })
      return Promise.reject(response.data)
    } else {
      logoutWarngingFlag = false
    }
    return response.data.data
  },
  error => {
    // 上传文件类型已在请求拦截器中提示，此处不再重复报错
    if (error && error.forbiddenFile) {
      return Promise.reject(error)
    }
    // 静默请求不弹任何提示，避免登录页出现“登录状态已过期”等无关弹窗
    if (error && error.config && error.config.silentError) {
      return Promise.reject(error)
    }
    // console.log('error', error)
    if (error.toString().indexOf('timeout') !== -1) {
      Notification.error({
        title: '网络繁忙，请稍后再试',
        duration: 5000
      })
      return Promise.reject(error)
    } else if (error.toString().indexOf('401') !== -1) {
      if (!logoutWarngingFlag) {
        logoutWarngingFlag = true
        MessageBox.confirm(
          '由于您长时间未操作，系统自动退出登录。',
          '系统提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning',
            showCancelButton: false
          }
        ).then(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        }).catch(() => {
          logoutWarngingFlag = false
        })
      }
    } else if (error.toString().indexOf('506') !== -1) {
      if (!logoutWarngingFlag) {
        logoutWarngingFlag = true
        MessageBox.confirm(
          '您的账号已在其他设备成功登录！',
          '系统提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning',
            showCancelButton: false
          }
        ).then(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        }).catch(() => {
          logoutWarngingFlag = false
        })
      }
    }
    else if (error.toString().indexOf('403') !== -1) {
      router.push({ path: '/401' })
    } else if (error.toString().indexOf('404') !== -1) {
      Notification.error({
        title: '接口地址不存在',
        duration: 5000
      })
    } else if (axios.isCancel(error)) {
      // Notification.error({
      //   title: '已取消请求',
      //   duration: 5000
      // })
    } else {
      Notification.error({
        title: '系统繁忙，请稍后再试',
        duration: 5000
      })
    }
    return Promise.reject(error)
  }
)
export default service
